<template>
  <div>
    <CRow>
      <CCol lg="6">
        <CTableWrapper
          :items="this.$store.state.leaderboard"
          hover
          striped
          bordered
          small
          fixed
          caption="League Table"
          v-on:row-clicked="onRowClicked"
        />
      </CCol>
      <CCol lg="6" id="team-view">
        <CTableWrapper
          :items="getTeamPlayers()"
          :fields="[{key:'team_name_short', label:''}, {key:'last_name', label:'Name'}, {key:'original_cost', label:'Value'}, {key:'week_points', label:'Week'}, {key:'total_points', label:'Total'}]"
          hover
          striped
          bordered
          small
          fixed
          :caption="getTeamTitle()"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import CTableWrapper from './Table.vue'

export default {
  name: 'Leaderboard',
  components: { CTableWrapper },
  props: {
      clubIndex: {
      type: Number,
      default: 0
    },
  },
  methods: {
      getTeamPlayers() {
        return this.$store.state.leaderboard.length > 0 ? this.$store.state.leaderboard[this.clubIndex].players : [];
      },
      getTeamTitle() {
          if(this.$store.state.leaderboard.length > 0) {
              let teamValue = 0;
              const playerArr = this.$store.state.leaderboard[this.clubIndex].players;
              for(var i = 0; i < playerArr.length; i++) {
                  teamValue += Number(playerArr[i].original_cost);
              }
              return `${this.$store.state.leaderboard[this.clubIndex].club_name} - £${teamValue/10}`;
          }
          return "";
      },
      onRowClicked(event) {
          const clubId = Number(event.club_id);
          const leaderboardArr = this.$store.state.leaderboard;
          for(var i = 0; i < leaderboardArr.length; i++) {
              if(leaderboardArr[i].club_id == clubId) {
                  break;
              }
          }
          this.clubIndex = i;

          var elmnt = document.getElementById("team-view");
          elmnt.scrollIntoView({ block: 'start',  behavior: 'smooth' });
      }
  }
}
</script>